import { render, staticRenderFns } from "./OutboxHeader.vue?vue&type=template&id=8b95eeea&scoped=true"
import script from "./OutboxHeader.vue?vue&type=script&lang=js"
export * from "./OutboxHeader.vue?vue&type=script&lang=js"
import style0 from "./OutboxHeader.vue?vue&type=style&index=0&id=8b95eeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95eeea",
  null
  
)

export default component.exports